import { render } from "./universalHeader.vue?vue&type=template&id=fb80f73a&ts=true"
import script from "./universalHeader.vue?vue&type=script&lang=ts"
export * from "./universalHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/universalHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb80f73a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb80f73a', __exports__)) {
    api.reload('fb80f73a', __exports__)
  }
  
  module.hot.accept("./universalHeader.vue?vue&type=template&id=fb80f73a&ts=true", () => {
    api.rerender('fb80f73a', render)
  })

}


export default __exports__